import { render, staticRenderFns } from "./AddPantalla.vue?vue&type=template&id=85fe17a8&"
import script from "./AddPantalla.vue?vue&type=script&lang=ts&"
export * from "./AddPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('85fe17a8', component.options)
    } else {
      api.reload('85fe17a8', component.options)
    }
    module.hot.accept("./AddPantalla.vue?vue&type=template&id=85fe17a8&", function () {
      api.rerender('85fe17a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Add/AddPantalla.vue"
export default component.exports